export const GET_ACTION_HISTORIES = 'GET_ACTION_HISTORIES';
export const GET_ACTION_HISTORIES_SUCCESS = 'GET_ACTION_HISTORIES_SUCCESS';
export const GET_ACTION_HISTORIES_FAILED = 'GET_ACTION_HISTORIES_FAILED';

export const EXPORT_ACTION_HISTORIES = 'EXPORT_ACTION_HISTORIES';
export const EXPORT_ACTION_HISTORIES_SUCCESS = 'EXPORT_ACTION_HISTORIES_SUCCESS';
export const EXPORT_ACTION_HISTORIES_FAILED = 'EXPORT_ACTION_HISTORIES_FAILED';
